import { Component, Emit, Provide, Ref, Vue } from 'vue-property-decorator'
import BillingModalCustomerCreationBasicFormComponent from '@/modules/billing-module/components/modal/customer/creation/components/basic-form/billing-modal-customer-creation-basic-form.vue'
import { BModal } from 'bootstrap-vue'
import {
    BillingModalCustomerCreationParams,
    BillingModalCustomerCreationState,
    initialBillingModalCustomerCreationState
} from '@/modules/billing-module/components/modal/customer/creation/billing-modal-customer-creation.model'
import {
    CustomerCreateRequest,
    CustomerResponse
} from '@/api/services/billing/common-customer/billing-common-customer.dto'
import { billingCommonCustomerService } from '@/api/services/billing/common-customer/billing-common-customer.service'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { store } from '@/store/store'
import { StrictNullable } from '@/shared/types/app.types'
import { CommonPatientResponse } from '@/api/services/common/patient/common-patient.dto'

@Component({
    components: {
        BillingModalCustomerCreationBasicFormComponent
    }
})
export default class BillingModalCustomerCreation extends Vue {
    @Ref() readonly customerCreationModal!: BModal

    @Provide() externalValidator = this.$validator

    @Emit()
    create(customer: CustomerResponse): CustomerResponse {
        return customer
    }

    state: BillingModalCustomerCreationState
    constructor() {
        super()
        this.state = initialBillingModalCustomerCreationState()
    }

    get modelValidated(): boolean {
        const hasErrors = this.errors.any()
        const isDirty = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    /// SERVICE CALLS ///

    private static async _createCustomer(request: CustomerCreateRequest): Promise<StrictNullable<CustomerResponse>> {
        return PromiseUtils.toCallSecure(
            billingCommonCustomerService.create(store.state.labId, request))
    }

    /// MODAL ///

    private _fillCustomerFromPatient(patient: CommonPatientResponse): void {
        const { fullName, mainPatientIdentifier } = patient

        this.state.customer.name = fullName
        this.state.customer.priorityForAutomaticAssignment = 1
        if (mainPatientIdentifier) {
            this.state.customer.taxIdentificationNumber = mainPatientIdentifier.paiIdentifier
            this.state.customer.code = mainPatientIdentifier.paiIdentifier
        }
    }
    show(params: BillingModalCustomerCreationParams): void {
        const { patient } = params
        this.state = initialBillingModalCustomerCreationState()
        this._fillCustomerFromPatient(patient)
        this.customerCreationModal.show()
    }
    hide(): void {
        this.customerCreationModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            const { name, code, taxIdentificationNumber, active, priorityForAutomaticAssignment, type, group } = this.state.customer as CustomerResponse
            const request: CustomerCreateRequest = {
                name,
                code,
                taxIdentificationNumber,
                active,
                priorityForAutomaticAssignment,
                customerTypeId: type.id,
                customerGroupId: group.id,
                breakdownDeliveryNotesByCaseType: false, // TODO: pending to implement
                breakdownDeliveryNotesByPatient: false, // TODO: pending to implement
                breakdownDeliveryNotesByRegime: false // TODO: pending to implement
            }
            const customer = await BillingModalCustomerCreation._createCustomer(request)
            if (customer !== null) {
                this.create(customer) // emits an event
                this.hide()
            }
        }
    }
}
